/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { connect } from '@airglow/store-redux';
import { selectEventsList } from '@nebula/dorado-redux-storage';
import SessionCreateModal from '../../ui/session-create-modal';
import connectedImage from '../../../images/S_IlluConnectionEstablished_57x114.png';
import connectImage from '../../../images/S_IlluPipeConnecting_240x120.gif';

import { showCreate } from '../../casing/data/prefabs';
import { quickConnect as showQuickConnect } from '../../casing/data/feature.flags';
import getEnv from '../../casing/env';
import { navigateToSessionView } from '../../common/actions';
import {
  selectActiveSessionLink,
  selectActiveSessionToken,
  selectImsConfig
} from '../../common/selectors';
import { createForm } from '../data/form.prefabs';
import { createSessionStepIndex, quickConnect, saving } from '../data/prefabs';
import { sessionSaveDuplicateError, sessionSaveError } from '../../ui/toast.list';
import { isSessionDuplicate } from '../../common/util/session.utils';

const mapState = (state) => {
  const stepIndex = createSessionStepIndex.value(state);
  const connected = selectEventsList(state).length > 0;
  const { imsAccessToken, imsOrg } = selectImsConfig(state);

  return {
    connecting: !connected,
    image: connected ? connectedImage : connectImage,
    link: selectActiveSessionLink(createForm, state),
    open: showCreate.isOn(state),
    pin: selectActiveSessionToken(state),
    quickConnect: quickConnect.isSet(state),
    quickConnectConfig: { env: getEnv(), imsOrg, imsToken: imsAccessToken },
    saving: saving.isSet(state),
    showQuickConnectOption: showQuickConnect(state),
    stepIndex,
    ...createForm.state(state)
  };
};

const mapHandlers = (dispatch) => {
  const { onReset, onSubmit, ...others } = createForm.handlers(dispatch);

  return ({
    createForm: {
      onReset,
      onSubmit
    },
    onConnectedDevice: ({ session }) => {
      dispatch(createSessionStepIndex.changeAction(2));
      dispatch(navigateToSessionView({ session: session.uuid }));
    },
    onErrorDevice: (e) => {
      const toastError = isSessionDuplicate(e) ? sessionSaveDuplicateError : sessionSaveError;
      dispatch(toastError);
    },
    onQuickConnect: () => dispatch(quickConnect.toggleAction),
    onStepIndexChange: stepIndex => dispatch(createSessionStepIndex.changeAction(stepIndex)),
    ...others
  });
};

export default connect(mapState, mapHandlers)(SessionCreateModal);
